import i18n from 'modules/core/lib/i18n'

import { AggregatedStatus } from 'modules/integrations/lib/syncableStatus'

export const translatedAggregatedStatus = (
  aggregatedStatus: AggregatedStatus,
  isExportMode: boolean
): string => {
  if (isExportMode) {
    switch (aggregatedStatus) {
      case 'syncing':
        return i18n.t('integrations.export_tooltips.exporting')
      case 'pending':
        return i18n.t('integrations.export_tooltips.pending')
      case 'outdated':
        return i18n.t('integrations.export_tooltips.outdated')
      case 'partiallySynced':
        return i18n.t('integrations.export_tooltips.partially_exported')
      case 'failed':
        return i18n.t('integrations.export_tooltips.failed')
      case 'synced':
        return i18n.t('integrations.export_tooltips.exported')
      default:
        throw new Error(`Unknown aggregated status: ${aggregatedStatus}`)
    }
  }

  switch (aggregatedStatus) {
    case 'syncing':
      return i18n.t('integrations.sync_tooltips.syncing')
    case 'pending':
      return i18n.t('integrations.sync_tooltips.pending')
    case 'outdated':
      return i18n.t('integrations.sync_tooltips.outdated')
    case 'partiallySynced':
      return i18n.t('integrations.sync_tooltips.partially_synced')
    case 'failed':
      return i18n.t('integrations.sync_tooltips.failed')
    case 'synced':
      return i18n.t('integrations.sync_tooltips.synced')
    default:
      throw new Error(`Unknown aggregated status: ${aggregatedStatus}`)
  }
}
